import { useSelection } from "@/contexts/SelectionContext";
import { Button, Modal } from "@ai-teach/ui-web";

interface DeleteModalProps {
  isOpen: boolean;
}

export function LinkedParentWarningModal({ isOpen }: DeleteModalProps) {
  const { toggleLinkedParentWarningModal } = useSelection();

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={() => {}} title="Warning" size="sm" style="danger">
      <div className="flex flex-col">
        <p className="text-secondary-200 mb-6 text-center">
          Oops! This item has linked copies. Please remove them before deleting.
        </p>

        <div className="flex gap-3 justify-center">
          <Button onClick={() => toggleLinkedParentWarningModal(false)} variant="secondary">
            Ok
          </Button>
        </div>
      </div>
    </Modal>
  );
}
